import { IComponentsConfig } from '../../_Common/Components/BusinessCollectionComponents/businessCollectionComponents';
import { initConst } from '../../../../Utils/utils';
import { AktuellaAvlidna } from './AktuellaAvlidna/AktuellaAvlidna';

export const BJVyer = initConst<IComponentsConfig>(() => ({
  BOBisattning: [AktuellaAvlidna],
}));
